import React, { useState, useEffect } from "react";
import { Button, InputLabel, MenuItem, Select, Switch, TextField } from "@mui/material";

function Prestamo({ formValues, handleFormChange }) {
  const [mesesFinanciar, setMesesFinanciar] = useState(formValues.mesesFinanciar);
  const [montoInicialCheck, setmontoInicialCheck] = useState(false);
  const [institucionFinanciera, setInstitucionFinanciera] = useState(formValues.institucionFinanciera);

  // Check if montoFinanciar is >= 100,000
  const montoFinanciarValue = parseFloat(formValues.montoFinanciar) || 0;
  const allowExtendedTerms = montoFinanciarValue >= 100000;

  // Reset mesesFinanciar if 48 or 60 is selected and amount becomes less than 100,000
  useEffect(() => {
    if ((mesesFinanciar === "48" || mesesFinanciar === "60") && !allowExtendedTerms) {
      setMesesFinanciar("");
      formValues.mesesFinanciar = "";
    }
  }, [formValues.montoFinanciar, allowExtendedTerms]);

  const handleMesesChange = (e) => {
    formValues.mesesFinanciar = e.target.value;
    setMesesFinanciar(e.target.value);
    console.log(formValues);
  };

  const handleInstitucionFinancieraChange = (e) => {
    formValues.institucionFinanciera = e.target.value;
    setInstitucionFinanciera(e.target.value);
    console.log(formValues);
  };

  const handleCheckMontoInicial = (e) => {
    if (!e) {
      formValues.montoInicial = "";
    }
    setmontoInicialCheck(!e);
  };

  return (
    <div style={{ margin: 15 }}>
      <TextField
        sx={{ marginTop: 3 }}
        label="Monto a Financiar"
        name="montoFinanciar"
        variant="standard"
        type="number"
        inputProps={{ pattern: "[0-9]*" }}
        value={formValues.montoFinanciar || " "}
        onChange={handleFormChange}
        fullWidth
        required
        error={!formValues.montoFinanciar}
        helperText={formValues?.montoFinanciar === "" ? "Debe llenar este campo" : null}
      />
      <span hidden={!montoInicialCheck}>
        {" "}
        <TextField
          sx={{ marginTop: 3 }}
          label="Monto Inicial"
          name="montoInicial"
          type="number"
          inputProps={{ pattern: "[0-9]*" }}
          variant="standard"
          value={formValues.montoInicial}
          onChange={handleFormChange}
          fullWidth
          hidden={true}
        />
      </span>
      <span>
        <Button sx={{ mt: 3 }} style={{ color: "black" }} onClick={() => handleCheckMontoInicial(montoInicialCheck)}>
          Desea dar un Monto Inicial
          <Switch color="success" defaultChecked={false} />
        </Button>
      </span>

      {/* <TextField
        sx={{ marginTop: 2 }}
        label="Meses Financiar"
        name="mesesFinanciar"
        variant="standard"
        value={formValues.mesesFinanciar}
        onChange={handleFormChange}
        fullWidth
        required
        error={!formValues.mesesFinanciar}
        helperText={formValues.mesesFinanciar === "" ? "Debe llenar este campo" : null}
      /> */}

      <div>
        <InputLabel sx={{ marginTop: 3 }} id="mesesFinanciar">
          Meses Financiar
        </InputLabel>
        <Select
          sx={{ minWidth: "100%" }}
          labelId="mesesFinanciar"
          id="mesesFinanciar"
          value={mesesFinanciar}
          label="mesesFinanciar"
          onChange={handleMesesChange}
          required
        >
          <MenuItem value={"6"}>6</MenuItem>
          <MenuItem value={"12"}>12</MenuItem>
          <MenuItem value={"18"}>18</MenuItem>
          <MenuItem value={"24"}>24</MenuItem>
          <MenuItem value={"36"}>36</MenuItem>
          {allowExtendedTerms && <MenuItem value={"48"}>48</MenuItem>}
          {allowExtendedTerms && <MenuItem value={"60"}>60</MenuItem>}
        </Select>
      </div>
      <div>
        <InputLabel sx={{ marginTop: 3 }} id="mesesFinanciar">
          Institución Financiera Preferida?
        </InputLabel>
        <Select
          sx={{ minWidth: "100%" }}
          labelId="institucionFinanciera"
          id="institucionFinanciera"
          value={institucionFinanciera}
          label="institucionFinanciera"
          onChange={handleInstitucionFinancieraChange}
          required
        >
          <MenuItem value={"0"}>Ninguna</MenuItem>
          <MenuItem value={"1"}>Popular</MenuItem>
          <MenuItem value={"2"}>Promerica</MenuItem>
          <MenuItem value={"3"}>Credicefi</MenuItem>
        </Select>
      </div>
    </div>
  );
}

export default Prestamo;
